import { render } from "./ModalProductBatchReport.vue?vue&type=template&id=62eb944e"
import script from "./ModalProductBatchReport.vue?vue&type=script&lang=js"
export * from "./ModalProductBatchReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__